/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const EmailChangePendingNewConfirmParser = 
/* #__PURE__ */ parsers.object([
    ['id', codecString],
    ['status', /* #__PURE__ */ parsers.exactly('pending_new_confirm')],
]);
export class EmailChangePendingNewConfirm extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return EmailChangePendingNewConfirmParser.decode(input).map(res => new EmailChangePendingNewConfirm(res));
    }
    static unsafeDecode(input) {
        return EmailChangePendingNewConfirm.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return EmailChangePendingNewConfirmParser.encode(data);
    }
    static schema() {
        return EmailChangePendingNewConfirmParser.schema();
    }
}
